import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../TimeModal/TimeModalContext';

import Loading from '../Loading';

import styles from '../../styles/Settings.module.css';

const GeneralSettings = ({ userId, userRole = 'Арбитражный управляющий' }) => {
    const { openTimeModal } = useTimeModal();

    const [settings, setSettings] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);

    React.useEffect(() => { 
    const token = localStorage.getItem('token');

        axios.get(`/api/get-user-settings?user_id=${userId}`, {
            headers: {
            Authorization: `Bearer ${token}`,
            }
        }).then((response) => {
            setSettings(response.data);
        }).catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        }).finally(() => {
            setLoading(false);
            setReload(false);
        })
    }, [reload]);

    const changeNotificationSetting = (id, value) => {
        setLoading(true);

        axios.put(`/api/change-notification-setting`, {
            id,
            value
        })
        .then(() => {
            setReload(true);
            openTimeModal('Настройка успешно изменена', 'success');
        })
        .catch(() => {
            openTimeModal('Не удалось изменить настройку. Попробуйте снова', 'error');
        })
    }

    return (
    <>
        <div className={styles.openSectionHeader}>
            <h3>Настройки</h3>
            {loading && <Loading type='inline' />}
        </div>
        <div className={styles.openSectionMain} style={{gap: '10px'}}>
            {(settings.lenght===0 && loading) ? <Loading />
            :
            settings.map((setting, index) => {
                const isVisible =
                    (userRole === 'АппаратСРО' && (setting.category_of_visibility === 'АппаратСРО' || setting.category_of_visibility === 'Все')) ||
                    (userRole === 'Арбитражный управляющий' && (setting.category_of_visibility === 'Арбитражный управляющий' || setting.category_of_visibility === 'Все'));

                if (!isVisible) return null;

                return (
                    <div className={styles.settingLine} key={index}>
                        <a className={styles.settingLabel}>{setting.setting_description}</a>
                        <div className='checkboxWrapper'>
                            <label className='switch' htmlFor={`${setting.setting_name}`}>
                                <input 
                                    type='checkbox'
                                    id={`${setting.setting_name}`}
                                    checked={setting.value === '1'} 
                                    onChange={(e) => {
                                        changeNotificationSetting(setting.id, e.target.checked);
                                    }}
                                />
                                <div className='slider round'></div>
                            </label>
                        </div>
                    </div>
                );
            })}
        </div>
    </>
    )
}

export default GeneralSettings;